<template>
  <div @mousemove="() => (hover = true)" @mouseleave="() => (hover = false)">
    <!-- 显示时间时分空间 -->
    <TimeConfigs v-if="sourceItem.key == 'time'" :hover="hover" />
    <div v-else class="item mt-2.5 bg-[#2c2c2c] box-border rounded-xl p-4">
      <div class="flex justify-between box-border items-center">
        <span class="opacity-70">
          {{ sourceItem.label + (labelUnit ? `（${labelUnit}）` : '') }}
        </span>
        <div
          class="flex items-center border border-transparent"
          :class="{
            '!border-border-active': hover
          }"
        >
          <a-time-picker
            v-if="usingTimePicker"
            v-model:value="timeDay"
            :use-12-hours="!isMiscIs24H"
            :allow-clear="false"
            :show-now="false"
            :format="timeFormat"
            input-read-only
            @change="onTimeChange"
          >
            <template #suffixIcon />
          </a-time-picker>
          <!-- 显示selec框 -->
          <!-- 枚举类型的数据需要用select框：包括string和number类型 -->
          <a-select
            v-else-if="usingSelect"
            v-model:value="sourceVal"
            :bordered="false"
            class="max-w-<160> font-medium text-base"
            :options="options"
            @change="onSelectChange"
          >
            <template #suffixIcon>
              <span class="flex items-center">
                <icon
                  icon="arrow-down.svg"
                  :width="12"
                  :height="12"
                  fill="none"
                />
              </span>
            </template>
          </a-select>
          <!-- 数字类型 -->
          <a-input-number
            v-else-if="usingNumberInput"
            v-model:value="sourceVal"
            class="w-20"
            :min="maxmin.min"
            :max="maxmin.max"
            :precision="precision"
            :controls="false"
            :step="precision ? Math.pow(0.1, precision) : 1"
            @change="onNumberChange"
          />
          <!-- 字符串类型 -->
          <a-input
            v-else-if="usingInput"
            v-model:value="sourceVal"
            class="w-36"
            @change="onInputChange"
          />
          <div
            v-if="sourceItem.key === DataSourceKey.tianSeFull"
            class="flex justify-between box-border items-center"
          >
            <span class="opacity-70"
              >{{ runtimeStore.configDataWhole[DataSourceKey.tianSeFull] }}
            </span>
          </div>
          <div
            v-else-if="sourceItem.key === DataSourceKey.tianseSimple"
            class="flex justify-between box-border items-center"
          >
            <span class="opacity-70">{{
              runtimeStore.configDataWhole[DataSourceKey.tianseSimple]
            }}</span>
          </div>
        </div>
      </div>
      <!-- slider -->
      <div v-if="usingSlider" class="slider mt-4">
        <a-slider
          v-model:value="sliderValue"
          :min="maxmin.min"
          :max="Math.floor(maxmin.max)"
          :step="precision && !usingTimePicker ? Math.pow(0.1, precision) : 1"
          :tip-formatter="(val:number)=>tipFormatter(val,sourceItem)"
          @change="onSliderChange"
        />
      </div>
      <!-- 农历信息 -->
      <div
        v-if="sourceItem.lunarKey"
        class="flex justify-between box-border items-center mt-4"
      >
        <span class="opacity-70">农历</span>
        <span class="opacity-70">{{
          runtimeStore.configDataWhole[sourceItem.lunarKey]
        }}</span>
      </div>
      <!-- 星期 -->
      <div
        v-if="sourceItem.key == 'dateDay'"
        class="flex justify-between box-border items-center mt-4"
      >
        <span class="opacity-70">星期</span>
        <span class="opacity-70">{{
          runtimeStore.configDataWhole['dateWeekStringFullCN']
        }}</span>
      </div>
      <!-- 月相 -->
      <div v-if="sourceItem.key == 'dateDay' && usingDateMoonSources.length">
        <div
          v-for="val in usingDateMoonSources"
          :key="val.key + val.title"
          class="flex justify-between box-border items-center mt-4"
        >
          <span class="opacity-70">{{ val.title }}</span>
          <span class="opacity-70">{{
            getMoonPhaseRanges(val.key).value
          }}</span>
        </div>
      </div>
      <!-- 禁飞时间 -->
      <div v-if="isNoFlyTimeOrSitTime">
        <div class="flex justify-between box-border items-center mt-4">
          <span class="opacity-70">时间</span>
          <span class="opacity-70">{{
            appSportNoFlyTimeLabel
              ? `${appSportNoFlyTimeLabel.val}${appSportNoFlyTimeLabel.unit}`
              : '-'
          }}</span>
        </div>
        <div class="flex justify-between box-border items-center mt-4">
          <span class="opacity-70">单位</span>
          <span class="opacity-70">{{
            appSportNoFlyTimeLabel ? `${appSportNoFlyTimeLabel.unit}` : '-'
          }}</span>
        </div>
      </div>
      <!-- 12小时制 -->
      <div v-if="sourceItem.key == 'timeHour'">
        <div class="flex justify-between box-border items-center mt-4">
          <span class="opacity-70">12小时制</span>
          <span class="opacity-70">{{
            runtimeStore.configDataWhole['timeHour12H']
          }}</span>
        </div>
      </div>
      <!-- 时辰 -->
      <div v-if="sourceItem.key == 'timeHour'">
        <div class="flex justify-between box-border items-center mt-4">
          <span class="opacity-70">时辰</span>
          <span class="opacity-70">{{
            runtimeStore.configDataWhole['timeChineseTimeString']
          }}</span>
        </div>
      </div>

      <!-- 空气质量等级 -->
      <div v-if="sourceItem.key == 'weatherCurrentAirQualityIndex'">
        <div class="flex justify-between box-border items-center mt-4">
          <span class="opacity-70">空气质量等级</span>
          <span class="opacity-70">{{
            runtimeStore.configDataWhole['weatherCurrentAirQualityLevelLabel']
          }}</span>
        </div>
      </div>
      <!-- 心率区间 -->
      <div v-if="sourceItem.key == 'healthHeartRate'">
        <div class="flex justify-between box-border items-center mt-4">
          <span class="opacity-70">心率区间</span>
          <span class="opacity-70">{{
            runtimeStore.configDataWhole['healthHeartRateZoneString']
          }}</span>
        </div>
      </div>
      <!-- 指南针方向 -->
      <div v-if="sourceItem.key == 'systemSensorCompass'">
        <div class="flex justify-between box-border items-center mt-4">
          <span class="opacity-70">指南针方向</span>
          <span class="opacity-70">{{
            runtimeStore.configDataWhole['systemSensorCompassDirection']
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue';
import { useDataSource } from '@/hooks';
import { ref } from 'vue';
import { computed } from 'vue';
import { watch } from 'vue';
import dayjs, { Dayjs } from 'dayjs';
import { useRuntimeStore } from '@/store/use-runtime-store';
import { DataSourceKey } from '@/resources/enum';

const { configData, setValues } = useDataSource();
const runtimeStore = useRuntimeStore();
const hover = ref(false);

const props = defineProps({
  sourceItem: {
    type: Object as PropType<DataSourceItem>,
    required: true
  },
  keys: {
    type: Array as PropType<string[]>,
    required: true
  }
});

const isNoFlyTimeOrSitTime = computed(() => {
  return ['appSportNoFlyTime', 'appSportSitTime'].includes(
    props.sourceItem.key
  );
});

const labelUnit = computed(() => {
  // 修改：在subunit_1数据源名称上增加上单位信息，这样就不用单独展示单位了
  // return tag == 'subunit_1' ? unit : '';
  if (isNoFlyTimeOrSitTime.value) return '分钟';
  return '';
});

const usingTimePicker = computed(() => {
  const key = props.sourceItem.key;
  return ['weatherCurrentSunRise', 'weatherCurrentSunSet', 'appAlarm'].includes(
    key
  );
});

const isMiscIs24H = computed(() => configData.value['miscIs24H'] == 1);
const timeFormat = computed(() =>
  isMiscIs24H.value
    ? 'HH:mm'
    : 'h:mm ' + ((timeDay.value?.hour() ?? 0) >= 12 ? '下午' : '上午')
);

const usingSelect = computed(() => {
  const sourceItem = props.sourceItem;
  return !!sourceItem.labelRange || !!sourceItem.weatherValueRange;
});

const usingNumberInput = computed(() => {
  const sourceItem = props.sourceItem;
  return (
    sourceItem.minValue !== undefined &&
    sourceItem.maxValue !== undefined &&
    !isTianSeDataSource.value
  );
});

// 天色数据源不使用输入框
const usingInput = computed(() => {
  return !isTianSeDataSource.value;
});

const isTianSeDataSource = computed(() => {
  const key = props.sourceItem.key;

  return [DataSourceKey.tianseSimple, DataSourceKey.tianSeFull].includes(
    key as DataSourceKey
  );
});

const precision = computed(() => {
  const { precision } = props.sourceItem;
  return isNoFlyTimeOrSitTime.value ? 0 : precision ?? 0;
});

const maxmin = computed(() => {
  const key = props.sourceItem.key;
  const { minValue = 0, maxValue = 0 } = props.sourceItem;

  // 如果是禁飞时间，单位：分钟
  if (isNoFlyTimeOrSitTime.value) {
    return {
      max: 60 * 24 * 3.5,
      min: 0
    };
  }

  if (usingTimePicker.value) {
    return {
      max: 60 * 24 - 1,
      min: 0
    };
  }
  // 最大值取决于目标值
  const progressKeys = [
    {
      value: 'healthStepCount',
      target: 'healthStepTarget'
    },
    {
      value: 'healthCalorieValue',
      target: 'healthCalorieTarget'
    },
    {
      value: 'healthStandCount',
      target: 'healthStandTarget'
    },
    {
      value: 'healthExerciseDuration',
      target: 'healthExerciseTarget'
    },
    {
      value: 'healthSleepDuration',
      target: 'healthSleepTarget'
    }
  ];
  const progressItem = progressKeys.find((item) => item.value == key);
  if (progressItem && props.keys.includes(progressItem.target)) {
    const max = configData.value[progressItem.target];

    return {
      min: minValue,
      max: max !== undefined ? Number(max) : maxValue
    };
  }
  if (key == 'dateDay') {
    // 如果是dateDay，最大值是变动的，需要获取当月最大值
    const year = Number(configData.value['dateYear']);
    const month = Number(configData.value['dateMonth']);
    const oDay = dayjs(`${year}-${month}`);
    return {
      min: 1,
      max: oDay.daysInMonth()
    };
  } else {
    // 时分秒需要-1
    const isTimeKey = [
      'timeMinute',
      'timeSecond',
      'timeHour',
      'dualtimeMinute',
      'dualtimeSecond',
      'dualtimeHour'
    ].includes(key);
    return {
      min: minValue,
      max: isTimeKey ? maxValue - 1 : maxValue
    };
  }
});

const usingSlider = computed(() => {
  const sourceItem = props.sourceItem;
  return (
    usingNumberInput.value &&
    !sourceItem.weatherValueRange &&
    (sourceItem.maxValue ?? 0) - (sourceItem.minValue ?? 0) >= 3 &&
    !isTianSeDataSource.value
  );
});

const sourceVal = ref<string | number>();
const timeDay = ref<Dayjs>();
const sliderValue = ref<number>();
const _setValue = (v: string | number) => {
  setValues({
    [props.sourceItem.key]: v
  });
};

watch(
  configData,
  () => {
    const { key } = props.sourceItem;

    sourceVal.value = configData.value[key];

    if (usingTimePicker.value) {
      const hour = Number(configData.value[key + 'Hour']);
      const minute = Number(configData.value[key + 'Minute']);
      timeDay.value = dayjs(`2008-09-09 ${hour}:${minute}:00`);
      // console.log('初始化数据', value);
      if (key.includes('weatherCurrentSun'))
        sliderValue.value = hour * 60 + minute;
    } else {
      sliderValue.value = Number(sourceVal.value);
    }
  },
  { immediate: true }
);

// 时间选择器
const onTimeChange = (data: Dayjs) => {
  const hour = data.hour();
  const minute = data.minute();
  const key = props.sourceItem.key;
  setValues({
    [key + 'Hour']: hour,
    [key + 'Minute']: minute
  });
};

const onSliderChange = (value: number) => {
  if (usingTimePicker.value) {
    const hour = Math.floor(value / 60);
    const minute = value % 60;
    const key = props.sourceItem.key;
    setValues({
      [key + 'Hour']: hour,
      [key + 'Minute']: minute
    });
  } else {
    _setValue(value);
  }
};

const onSelectChange = (v: number | string) => {
  _setValue(v);
};
const onNumberChange = (v: number) => {
  _setValue(v);
};
const onInputChange = (v: number) => {
  console.log('onInputChange', v);
};

const options = computed(() => {
  const { minValue, maxValue, labelRange } = props.sourceItem;
  const res: { label: string; value: number | string }[] = [];

  if (weatherLabelValueRange.value?.length) {
    weatherLabelValueRange.value.forEach((item) => {
      const { value, label } = item;
      res.push({
        label: label,
        value
      });
    });
    return res;
  }
  // 代表数字类型
  if (minValue !== undefined && maxValue !== undefined) {
    const len = maxValue - minValue;
    for (let i = 0; i <= len; i++) {
      const val = i + minValue;
      res.push({
        value: val,
        label: labelRange?.[i] ? labelRange?.[i] : val + ''
      });
    }
  } else {
    // 代表字符串类型
    labelRange?.forEach((item) => {
      res.push({
        label: item,
        value: item
      });
    });
  }
  return res;
});

const weatherLabelValueRange = computed(() => {
  return props.sourceItem.weatherValueRange?.['whole'];
});

const tipFormatter = (value: number, item: DataSourceItem): string => {
  if (usingTimePicker.value) {
    return timeDay.value?.format(timeFormat.value) ?? '';
  }
  let str: string | number | undefined = '';
  const { labelRange } = item;
  const isInputType = !!labelRange || !!weatherLabelValueRange.value?.length;
  if (isInputType) {
    const option = (labelRange ?? weatherLabelValueRange.value)?.[value];
    str = option ? `${option}` : '';
  } else {
    str = `${value}`;
  }
  return str;
};

const appSportNoFlyTimeLabel = computed(() => {
  const key = props.sourceItem.key;
  const unitKey = key + 'UnitLabel';
  const val = runtimeStore.configDataWhole[key];
  const label = runtimeStore.configDataWhole[unitKey];
  if (Number.isNaN(val)) return;
  return {
    val,
    unit: label
  };
});

const dateMoonSources = [
  {
    key: 'dateMoon',
    title: '今日月相'
  },
  {
    key: 'dateMoonTomorrow',
    title: '明日月相'
  },
  {
    key: 'dateMoonAfterTomorrow',
    title: '后日月相'
  },
  {
    key: 'dateMoonThreeTomorrow',
    title: '3天后月相'
  },
  {
    key: 'dateMoonFourDaysAgo',
    title: '4天后月相'
  },
  {
    key: 'dateMoonFiveDaysAgo',
    title: '5天后月相'
  },
  {
    key: 'dateMoonSixDaysAgo',
    title: '6天后月相'
  }
];

const moonPhaseRanges: Record<number, string> = {
  0: '新月',
  1: '娥眉月',
  2: '上弦月',
  3: '盈凸月',
  4: '满月',
  5: '亏凸月',
  6: '下弦月',
  7: '残月'
};

const getMoonPhaseRanges = (key: string) =>
  computed(() => {
    return moonPhaseRanges[runtimeStore.configDataWhole[key] as number];
  });

const curUsingDataSources = computed(() => runtimeStore.configData);
// const curUseDatasource = runtimeStore.configData;

const usingDateMoonSources = computed(() => {
  const usingSources = Object.keys(curUsingDataSources.value ?? {});
  if (usingSources.length)
    return dateMoonSources.filter((item) => usingSources.includes(item.key));
  return [];
});
</script>
<style lang="less" scoped>
.item {
  &:deep(.ant-slider) {
    .ant-slider-track {
      box-sizing: border-box;
      background-color: #0d84f2;
    }
    .ant-slider-rail {
      border-radius: 5px;
      background-color: #626262;
    }
    .ant-slider-handle {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 2px solid #fff;
    }
    .ant-slider-dot-active {
      border-color: #fff;
    }
  }
  &:deep(.ant-input-number),
  &:deep(.ant-picker) {
    border: none;
    input {
      text-align: right;
      font-size: 16px;
      font-weight: 500;
    }
    .ant-input-number-input {
      padding-right: 0px;
    }
  }
  &:deep(.ant-select-selector > .ant-select-selection-item) {
    text-align: right;
  }
}
</style>
